import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetLearningHubTestContent = (testId: string) => {
  const service = useServices().learningHubService;
  return useQuery({
    queryKey: ['learningHubTestContent', testId],
    queryFn: () => service.getLearningHubTestContent(testId),
    refetchOnWindowFocus: false,
    gcTime: 0,
  });
};

export const useGetModuleDetails = (slug: string) => {
  const service = useServices().learningHubService;
  return useQuery({
    queryKey: ['moduleDetails', slug],
    queryFn: () => service.getModuleDetails(slug),
    enabled: !!slug,
    refetchOnWindowFocus: false,
  });
};

export const useGetModuleTableOfContents = (moduleId: string) => {
  const service = useServices().learningHubService;
  return useQuery({
    queryKey: ['moduleContents', moduleId],
    queryFn: () => service.getModuleContents(moduleId),
    enabled: !!moduleId,
    refetchOnWindowFocus: false,
  });
}